import * as React from 'react';
import DocumentListCardAdmin from "./DocumentListCardAdmin";
import I18nUtils from "../../../../I18n/I18nUtils";
import {MenuIcon} from "../../../../Config";
import ScreenCard from '../../../../components/screen/ScreenCard';
import {TR_DOCUMENTACION} from "../../../../I18n/constants";
import {ROUTE_ADMIN_DOCUMENTS} from "../../../../routing/Routes";

export default class DocumentListAdminScreen extends React.Component<{}> {

    public render() {
        return (
            <ScreenCard breadcrumbs={[
                {
                    name: I18nUtils.tr(TR_DOCUMENTACION),
                    url: ROUTE_ADMIN_DOCUMENTS,
                    icon: MenuIcon.DOCUMENTATION,
                },
            ]}>
                <DocumentListCardAdmin/>
            </ScreenCard>
        )
    }
}